module.exports = __webpack_public_path__ + "static/img/sp_banner4.77e4b4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/sp/sp_banner4.png
// module id = vxRa
// module chunks = 0